// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/xdl/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rmsc {\r\n    --rmsc-border: none !important;\r\n}\r\n.rmsc .dropdown-content {\r\n    max-height: 150px;\r\n    overflow-y: auto;\r\n    z-index: 1050;\r\n    font-size: 14px !important;\r\n    position: relative;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
